import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { COMPANY } from "@/i18n/translations";

function LegalShell({ title, children }) {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="bg-obsidian min-h-screen">
      <Header />
      <div className="max-w-3xl mx-auto px-6 md:px-10 pt-36 pb-24">
        <h1 className="font-heading font-black uppercase tracking-tighter text-white text-4xl md:text-6xl mb-12">{title}</h1>
        <div className="space-y-6 text-zinc-300 leading-relaxed">{children}</div>
      </div>
      <Footer />
    </div>
  );
}

const H = ({ children }) => (
  <h2 className="font-heading text-brand-bright uppercase tracking-wider text-lg mt-8 mb-2">{children}</h2>
);

export function Impressum() {
  return (
    <LegalShell title="Impressum">
      <div data-testid="impressum-content">
        <H>Angaben gemäß § 5 DDG</H>
        <p>
          DNA Automotive GmbH<br />
          MotorWorld Köln-Rheinland<br />
          {COMPANY.addressLine}<br />
          {COMPANY.city}
        </p>
        <H>Vertreten durch</H>
        <p>Geschäftsführer: {COMPANY.managingDirector}</p>
        <H>Kontakt</H>
        <p>
          Telefon: {COMPANY.phone}<br />
          E-Mail: {COMPANY.email}
        </p>
        <H>Registereintrag</H>
        <p>
          Eintragung im Handelsregister.<br />
          Registergericht: {COMPANY.court}<br />
          Registernummer: {COMPANY.hrb}
        </p>
        <H>Steuernummer</H>
        <p>{COMPANY.taxNumber}</p>
        <H>Umsatzsteuer-ID</H>
        <p>
          Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
          {COMPANY.vatId}
        </p>
        <H>Erlaubnis nach § 34c GewO</H>
        <p>
          Erlaubnis zur Vermittlung von Verträgen über Darlehen (§ 34c GewO) erteilt durch das
          zuständige Ordnungsamt der Stadt Köln.
        </p>
        <H>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H>
        <p>{COMPANY.managingDirector}<br />{COMPANY.addressLine}, {COMPANY.city}</p>
        <H>Streitschlichtung</H>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
          {" "}
          <a href="https://ec.europa.eu/consumers/odr" className="text-brand-bright" target="_blank" rel="noreferrer">https://ec.europa.eu/consumers/odr</a>.
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </div>
    </LegalShell>
  );
}

export function Datenschutz() {
  return (
    <LegalShell title="Datenschutz">
      <div data-testid="datenschutz-content">
        <H>1. Datenschutz auf einen Blick</H>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir behandeln Ihre personenbezogenen
          Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften – insbesondere der
          Datenschutz-Grundverordnung (DSGVO) und des Bundesdatenschutzgesetzes (BDSG) – sowie dieser
          Datenschutzerklärung.
        </p>

        <H>2. Verantwortliche Stelle</H>
        <p>
          Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br /><br />
          {COMPANY.name}<br />
          MotorWorld Köln-Rheinland<br />
          {COMPANY.addressLine}, {COMPANY.city}<br />
          Telefon: {COMPANY.phone}<br />
          E-Mail: {COMPANY.email}
        </p>

        <H>3. Hosting und Server-Logfiles</H>
        <p>
          Beim Aufruf unserer Website werden durch den Hosting-Anbieter automatisch Informationen in sogenannten
          Server-Logfiles gespeichert (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs, aufgerufene Seite,
          Browsertyp und Betriebssystem). Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse am sicheren und stabilen Betrieb der Website). Eine Zusammenführung dieser Daten
          mit anderen Datenquellen findet nicht statt.
        </p>

        <H>4. Cookies und Einwilligungsmanagement</H>
        <p>
          Unsere Website verwendet Cookies. Technisch notwendige Cookies (z. B. zur Speicherung Ihrer Sprach- und
          Cookie-Einstellungen) sind für den Betrieb der Website erforderlich und werden auf Grundlage von
          § 25 Abs. 2 TDDDG gesetzt. Alle weiteren Cookies – insbesondere Statistik- und Analyse-Cookies – werden
          erst nach Ihrer ausdrücklichen Einwilligung über unser Cookie-Consent-Banner gesetzt (§ 25 Abs. 1 TDDDG
          i. V. m. Art. 6 Abs. 1 lit. a DSGVO). Ohne Ihre Einwilligung findet kein Tracking statt. Ihre Einwilligung
          können Sie jederzeit mit Wirkung für die Zukunft über den Link „Cookie-Einstellungen" im Footer dieser
          Website ändern oder widerrufen.
        </p>

        <H>5. Webanalyse mit PostHog (nur mit Einwilligung)</H>
        <p>
          Nach Ihrer Einwilligung setzen wir den Analysedienst PostHog ein, um die Nutzung unserer Website
          statistisch auszuwerten und unser Angebot zu verbessern. Dabei können insbesondere Informationen über
          Ihr Nutzungsverhalten (besuchte Seiten, Klicks, Verweildauer) sowie technische Informationen (Gerätetyp,
          Browser, gekürzte IP-Adresse) verarbeitet werden; teilweise werden Sitzungen als Aufzeichnung
          (Session Recording) gespeichert. Rechtsgrundlage ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
          Wenn Sie keine Einwilligung erteilen, wird PostHog nicht geladen und es findet keinerlei Tracking statt.
        </p>

        <H>6. Kontaktformular und E-Mail-Kontakt</H>
        <p>
          Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem
          Formular inklusive der angegebenen Kontaktdaten (Name, E-Mail-Adresse, ggf. Telefonnummer) zwecks
          Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Der Versand unserer
          E-Mails erfolgt über den Dienstleister Resend. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO
          (vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO. Diese Daten geben wir nicht ohne Ihre
          Einwilligung weiter.
        </p>

        <H>7. Ankauf- und Inzahlungnahme-Formular (inkl. Bild-Upload)</H>
        <p>
          Bei Nutzung unseres Ankauf- bzw. Inzahlungnahme-Formulars verarbeiten wir die von Ihnen angegebenen
          Daten (Kontaktdaten, Fahrzeugdaten sowie die hochgeladenen Fahrzeugbilder) ausschließlich zur
          Bearbeitung Ihrer Anfrage und zur Erstellung eines Angebots. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b
          DSGVO. Die hochgeladenen Bilder werden auf unserem Server gespeichert und nicht an Dritte weitergegeben.
        </p>

        <H>8. Kontaktaufnahme über WhatsApp</H>
        <p>
          Auf unserer Website bieten wir die Möglichkeit, uns über den Messenger-Dienst WhatsApp (Anbieter:
          WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland) zu kontaktieren.
          Wenn Sie den WhatsApp-Button anklicken, verlassen Sie unsere Website; es gelten die
          Datenschutzbestimmungen von WhatsApp. Eine Datenübertragung an WhatsApp findet erst statt, wenn Sie den
          Dienst aktiv nutzen.
        </p>

        <H>9. Lokale Schriftarten</H>
        <p>
          Die auf dieser Website verwendeten Schriftarten (Manrope, Cabinet Grotesk) werden lokal von unserem
          Server geladen. Es findet keine Verbindung zu Servern von Google Fonts oder anderen externen
          Schriftarten-Anbietern statt; Ihre IP-Adresse wird dabei nicht an Dritte übertragen.
        </p>

        <H>10. Speicherdauer</H>
        <p>
          Wir speichern personenbezogene Daten nur so lange, wie es für die jeweiligen Verarbeitungszwecke
          erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen. Anfragen über unsere Formulare werden
          nach abschließender Bearbeitung gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten
          entgegenstehen.
        </p>

        <H>11. Ihre Rechte</H>
        <p>
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen
          Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung (Art. 15 DSGVO), ein Recht auf
          Berichtigung (Art. 16 DSGVO), Löschung (Art. 17 DSGVO), Einschränkung der Verarbeitung (Art. 18 DSGVO),
          Datenübertragbarkeit (Art. 20 DSGVO) sowie ein Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO).
          Erteilte Einwilligungen können Sie jederzeit mit Wirkung für die Zukunft widerrufen (Art. 7 Abs. 3
          DSGVO), z. B. über die Cookie-Einstellungen im Footer oder per E-Mail an {COMPANY.email}.
        </p>

        <H>12. Beschwerderecht bei der Aufsichtsbehörde</H>
        <p>
          Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO). Zuständig
          ist die Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen (LDI NRW),
          Kavalleriestr. 2-4, 40213 Düsseldorf.
        </p>

        <H>13. SSL- bzw. TLS-Verschlüsselung</H>
        <p>
          Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine
          SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an „https://" in der
          Adresszeile Ihres Browsers.
        </p>

        <p className="text-zinc-500 text-sm pt-4">Stand: Juli 2026</p>
      </div>
    </LegalShell>
  );
}

export function AGB() {
  return (
    <LegalShell title="AGB">
      <div data-testid="agb-content">
        <p className="text-zinc-400 text-sm">Allgemeine Geschäftsbedingungen der DNA Automotive GmbH für Mietwagen und Auto-Abo.</p>

        <H>1. Geltungsbereich</H>
        <p>
          Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Verträge über die Überlassung von
          Fahrzeugen (Mietwagen) sowie für Auto-Abo-Verträge zwischen der {COMPANY.name}, {COMPANY.addressLine},{" "}
          {COMPANY.city} (nachfolgend „DNA Automotive") und dem Kunden. Abweichende Bedingungen des Kunden werden
          nicht Vertragsinhalt, es sei denn, DNA Automotive stimmt ihrer Geltung ausdrücklich schriftlich zu.
        </p>

        <H>2. Vertragsschluss</H>
        <p>
          Anfragen über unsere Website (Kontaktformular, E-Mail, WhatsApp) sind unverbindlich. Ein Vertrag kommt
          erst durch schriftliche Bestätigung bzw. durch Unterzeichnung des Miet- bzw. Abo-Vertrags zustande.
          DNA Automotive behält sich vor, Anfragen ohne Angabe von Gründen abzulehnen.
        </p>

        <H>3. Leistungen</H>
        <p>
          <strong>Mietwagen:</strong> Überlassung des gebuchten Fahrzeugs für den vereinbarten Zeitraum.
          Umfang (Freikilometer, Versicherung, Zusatzfahrer, Anlieferung) ergibt sich aus dem jeweiligen Angebot
          bzw. Mietvertrag.<br /><br />
          <strong>Auto-Abo:</strong> Überlassung eines Fahrzeugs zur monatlichen Pauschalrate mit den im
          jeweiligen Abo-Angebot genannten Leistungen (z. B. Versicherung, Wartung, Zulassung). Fahrzeugmodelle
          und -klassen richten sich nach Verfügbarkeit; ein Anspruch auf ein bestimmtes Fahrzeug besteht nur bei
          ausdrücklicher schriftlicher Zusage.
        </p>

        <H>4. Preise und Zahlung</H>
        <p>
          Es gelten die im Angebot bzw. Vertrag genannten Preise inklusive der gesetzlichen Mehrwertsteuer, soweit
          nicht anders ausgewiesen. Mietentgelte sind bei Fahrzeugübergabe fällig, Abo-Raten monatlich im Voraus.
          Zusätzliche Kilometer, Schäden, Minderaufladungen, Reinigungs- oder Rückgabekosten werden nach
          tatsächlichem Aufwand berechnet.
        </p>

        <H>5. Kaution und Versicherung</H>
        <p>
          Vor Fahrzeugübergabe kann eine Kaution fällig werden, deren Höhe sich nach Fahrzeugklasse richtet. Die
          Fahrzeuge sind haftpflicht- und vollkaskoversichert; die Selbstbeteiligung ergibt sich aus dem Vertrag.
          Die Kaution wird nach ordnungsgemäßer Rückgabe des Fahrzeugs zurückerstattet.
        </p>

        <H>6. Überlassung und Rückgabe</H>
        <p>
          Das Fahrzeug wird im vereinbarten Zustand übergeben und ist in gleichem Zustand, vollgetankt bzw.
          aufgeladen sowie gereinigt zurückzugeben. Die Rückgabe erfolgt zum vereinbarten Zeitpunkt am
          vereinbarten Ort (MotorWorld Köln-Rheinland, sofern nicht anders vereinbart).
        </p>

        <H>7. Pflichten des Kunden</H>
        <p>
          Der Kunde ist verpflichtet, das Fahrzeug sorgfältig zu behandeln, alle Verkehrsvorschriften
          einzuhalten und das Fahrzeug nicht an unberechtigte Dritte zu überlassen. Fahrer müssen im Besitz einer
          gültigen Fahrerlaubnis Klasse B sein. Bußgelder, Maut- und Parkgebühren während der Überlassungszeit
          trägt der Kunde.
        </p>

        <H>8. Haftung</H>
        <p>
          DNA Automotive haftet unbeschränkt bei Vorsatz, grober Fahrlässigkeit sowie bei Verletzung von Leben,
          Körper und Gesundheit. Im Übrigen haftet DNA Automotive nur bei Verletzung wesentlicher
          Vertragspflichten, begrenzt auf den vertragstypischen, vorhersehbaren Schaden. Schäden am Fahrzeug
          während der Mietzeit trägt der Kunde im Rahmen der vereinbarten Selbstbeteiligung.
        </p>

        <H>9. Laufzeit und Kündigung (Auto-Abo)</H>
        <p>
          Die Mindestlaufzeit und Kündigungsfristen des Auto-Abos ergeben sich aus dem jeweiligen Abo-Angebot.
          Nach Ablauf der Mindestlaufzeit kann das Abo monatlich mit der vereinbarten Frist gekündigt werden.
          Das Recht zur außerordentlichen Kündigung aus wichtigem Grund bleibt unberührt.
        </p>

        <H>10. Datenschutz</H>
        <p>
          Die Verarbeitung personenbezogener Daten erfolgt gemäß unserer Datenschutzerklärung, abrufbar unter
          dna-automotive.de/datenschutz.
        </p>

        <H>11. Schlussbestimmungen</H>
        <p>
          Es gilt das Recht der Bundesrepublik Deutschland. Erfüllungsort und Gerichtsstand ist – soweit
          gesetzlich zulässig – Köln. Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der
          übrigen Bestimmungen unberührt.
        </p>

        <p className="text-zinc-500 text-sm pt-4">Stand: Juli 2026</p>
      </div>
    </LegalShell>
  );
}

export function Widerruf() {
  return (
    <LegalShell title="Widerrufsbelehrung">
      <div data-testid="widerruf-content">
        <H>Widerrufsrecht</H>
        <p>
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die
          Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsschlusses.
        </p>
        <p>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns ({COMPANY.name}, {COMPANY.addressLine}, {COMPANY.city},
          Telefon: {COMPANY.phone}, E-Mail: {COMPANY.email}) mittels einer eindeutigen Erklärung (z. B. ein mit
          der Post versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen,
          informieren.
        </p>
        <p>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des
          Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
        </p>

        <H>Folgen des Widerrufs</H>
        <p>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben,
          einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass
          Sie eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt
          haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die
          Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden
          wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn,
          mit Ihnen wurde ausdrücklich etwas anderes vereinbart.
        </p>

        <H>Vorzeitiges Erlöschen des Widerrufsrechts</H>
        <p>
          Bei Verträgen über Dienstleistungen (z. B. Mietwagen und Auto-Abo) erlischt Ihr Widerrufsrecht
          vorzeitig, wenn wir die Dienstleistung vollständig erbracht haben und mit der Ausführung der
          Dienstleistung erst begonnen haben, nachdem Sie dazu Ihre ausdrückliche Zustimmung gegeben haben und
          gleichzeitig Ihre Kenntnis davon bestätigt haben, dass Sie Ihr Widerrufsrecht bei vollständiger
          Vertragserfüllung durch uns verlieren (§ 356 Abs. 5 BGB). Bei Verträgen zur Beförderung von
          Fahrzeugen bzw. zur Vermietung von Fahrzeugen zu einem bestimmten Termin oder Zeitraum besteht gemäß
          § 312g Abs. 2 Nr. 9 BGB kein Widerrufsrecht.
        </p>

        <p className="text-zinc-500 text-sm pt-4">Stand: Juli 2026</p>
      </div>
    </LegalShell>
  );
}
